export default __webpack_public_path__ + "static/media/blog-01.67ebb920.jpg";